// extracted by mini-css-extract-plugin
module.exports = {"custom_btn":"forgotPassword_custom_btn__lDsUe"};